import Empty from "../../assets/svgs/Empty";

interface EmptyStateProps {
  title?: string;
  description?: string;
  className?: string;
  theme?: string;
}

export function EmptyState({
  title = "No Items Found",
  description,
  className = "",
  theme = "light",
}: EmptyStateProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center p-6 ${className}`}
    >
      <Empty fill={theme === "dark" ? "black" : "#E8ECEF"} />
      <p className="mt-3 BookEZ_font_body_size_large BookEZ_font_body_large BookEZ_font_color_gray_4">
        {title}
      </p>
      {description && (
        <p className="BookEZ_font_body_size BookEZ_font_light_bold mt-2 BookEZ_font_color_gray_5">
          {description}
        </p>
      )}
    </div>
  );
}
